import { ref, computed } from '@vue/composition-api'
import { constants as c } from '@kingpin-global/kingpin-utils-frontend'
import store from '@/store'
import { GET_COMMON_AUTH } from '@/store/modules/common.module'
import { apiToastError } from '@/@core/utils/toast'

const { BRAND_ACCESS } = c

function parseBrandsResponse(resData) {
  const direct = resData?.DIRECT_BRANDS || []
  const marketplace = (resData?.BRANDS || []).filter(
    brand => brand?.access?.includes(BRAND_ACCESS.MARKETPLACE),
  )
  return { direct, marketplace }
}

export function useDashboardBrands() {
  const directBrands = ref([])
  const marketplaceBrands = ref([])
  const isLoadedAllBrands = ref(false)

  const profile = computed(() => store.state.auth.profileData)
  const isRetailer = computed(() => store.getters.isRetailer)

  const isEnabledMarketplace = computed(
    () => profile.value?.access?.includes(BRAND_ACCESS.MARKETPLACE),
  )

  const brands = computed(() => {
    const { DIRECT } = BRAND_ACCESS
    const access = profile.value?.access || []
    if (!access.length) {
      return []
    }
    const isRetailerDirectOnly = access.length === 1 && access.includes(DIRECT)
    const brandList = isRetailerDirectOnly
      ? directBrands.value
      : [...directBrands.value, ...marketplaceBrands.value]
    return brandList.slice(0, 4)
  })

  async function loadBrands() {
    if (!isRetailer.value) return
    try {
      const res = await store.dispatch(GET_COMMON_AUTH)
      const { direct, marketplace } = parseBrandsResponse(res?.data?.data)
      directBrands.value = direct
      marketplaceBrands.value = marketplace
    } catch (err) {
      apiToastError(err)
      directBrands.value = []
      marketplaceBrands.value = []
    } finally {
      isLoadedAllBrands.value = true
    }
  }

  return {
    directBrands,
    marketplaceBrands,
    isLoadedAllBrands,
    brands,
    profile,
    isEnabledMarketplace,
    loadBrands,
  }
}
